import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe/unsubscribe.component';
import { ResubscribePageComponent } from './components/resubscribe-page/resubscribe-page.component';

const routes: Routes = [
  {
    component: UnsubscribeComponent,
    path: 'unsubscribe',
  },
  {
    component: ResubscribePageComponent,
    path: 'resubscribe',
  },
  {
    component: UnsubscribeComponent,
    path: ':tenantId/:brandExternalId',
    pathMatch: 'full',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule { }



